import { createAction, props } from '@ngrx/store'

import { FolderTrafficStatus } from '../models/folder-traffic-status.interface'
import { FolderVersion } from '@app/core/model/folder-version.model'
import { SowRetainedHoursStats } from '@app/features/scope-overview/model/sow-retained-hours-stats.model'

export enum FolderOverviewActionTypes {
  GET_CURRENT_FOLDER = '[Folder Details] Get Current Folder',
  GET_CURRENT_FOLDER_FAIL = '[Folder Details] Get Current Folder Fail',
  GET_CURRENT_FOLDER_SUCCESS = '[Folder Details] Get Current Folder Success',

  DELETE_FOLDER = '[Folder Details] Delete Folder',
  DELETE_FOLDER_FAIL = '[Folder Details] Delete Folder Fail',
  DELETE_FOLDER_SUCCESS = '[Folder Details] Delete Folder Success',

  ARCHIVE_FOLDER = '[Folder Details] Archive Folder',
  ARCHIVE_FOLDER_FAIL = '[Folder Details] Archive Folder Fail',
  ARCHIVE_FOLDER_SUCCESS = '[Folder Details] Archive Folder Success',

  UNARCHIVE_FOLDER = '[Folder Details] Unarchive Folder',
  UNARCHIVE_FOLDER_FAIL = '[Folder Details] Unarchive Folder Fail',
  UNARCHIVE_FOLDER_SUCCESS = '[Folder Details] Unarchive Folder Success',

  UPDATE_FOLDER = '[Folder Details] Update Folder',
  UPDATE_FOLDER_FAIL = '[Folder Details] Update Folder Fail',
  UPDATE_FOLDER_SUCCESS = '[Folder Details] Update Folder Success',

  GET_RETAINED_HOURS_STATS = '[Folder Details] Get retained hours stats',
  GET_RETAINED_HOURS_STATS_FAIL = '[Folder Details] Get retained hours stats Fail',
  GET_RETAINED_HOURS_STATS_SUCCESS = '[Folder Details] Get retained hours stats Success',

  CHANGE_FOLDER_VERSION = '[Folder Details] Change folder version stats',
  CHANGE_FOLDER_VERSION_FAIL = '[Folder Details] Change folder version stats Fail',
  CHANGE_FOLDER_VERSION_SUCCESS = '[Folder Details] Change folder version stats Success',

  TRAFFIC_SCOPES = '[Folder Overview] Traffic Scopes',
  TRAFFIC_SCOPES_FAIL = '[Folder Overview] Traffic Scopes Fail',
  TRAFFIC_SCOPES_SUCCESS = '[Folder Overview] Traffic Scopes Success',
}

const getCurrentFolder = createAction(FolderOverviewActionTypes.GET_CURRENT_FOLDER)
const getCurrentFolderFail = createAction(FolderOverviewActionTypes.GET_CURRENT_FOLDER_FAIL, props<{ error: Error }>())
const getCurrentFolderSuccess = createAction(
  FolderOverviewActionTypes.GET_CURRENT_FOLDER_SUCCESS,
  props<{ folder: FolderVersion }>()
)

const deleteFolder = createAction(FolderOverviewActionTypes.DELETE_FOLDER, props<{ id: number }>())
const deleteFolderFail = createAction(FolderOverviewActionTypes.DELETE_FOLDER_FAIL, props<{ error: Error }>())
const deleteFolderSuccess = createAction(FolderOverviewActionTypes.DELETE_FOLDER_SUCCESS, props<{ id: number }>())

const archiveFolder = createAction(FolderOverviewActionTypes.ARCHIVE_FOLDER, props<{ id: number }>())
const archiveFolderFail = createAction(FolderOverviewActionTypes.ARCHIVE_FOLDER_FAIL, props<{ error: Error }>())
const archiveFolderSuccess = createAction(FolderOverviewActionTypes.ARCHIVE_FOLDER_SUCCESS, props<{ id: number }>())

const unarchiveFolder = createAction(FolderOverviewActionTypes.UNARCHIVE_FOLDER, props<{ id: number }>())
const unarchiveFolderFail = createAction(FolderOverviewActionTypes.UNARCHIVE_FOLDER_FAIL, props<{ error: Error }>())
const unarchiveFolderSuccess = createAction(FolderOverviewActionTypes.UNARCHIVE_FOLDER_SUCCESS, props<{ id: number }>())

const updateFolder = createAction(FolderOverviewActionTypes.UPDATE_FOLDER, props<{ changes: any }>())
const updateFolderFail = createAction(FolderOverviewActionTypes.UPDATE_FOLDER_FAIL, props<{ error: Error }>())
const updateFolderSuccess = createAction(
  FolderOverviewActionTypes.UPDATE_FOLDER_SUCCESS,
  props<{ folder: FolderVersion }>()
)

const getRetainedHoursStats = createAction(FolderOverviewActionTypes.GET_RETAINED_HOURS_STATS)
const getRetainedHoursStatsFail = createAction(
  FolderOverviewActionTypes.GET_RETAINED_HOURS_STATS_FAIL,
  props<{ error: Error }>()
)
const getRetainedHoursStatsSuccess = createAction(
  FolderOverviewActionTypes.GET_RETAINED_HOURS_STATS_SUCCESS,
  props<{ retainedHoursStats: SowRetainedHoursStats }>()
)

const changeFolderVersion = createAction(
  FolderOverviewActionTypes.CHANGE_FOLDER_VERSION,
  props<{ id: number; versionNumber: number }>()
)
const changeFolderVersionFail = createAction(
  FolderOverviewActionTypes.CHANGE_FOLDER_VERSION_FAIL,
  props<{ error: Error }>()
)
const changeFolderVersionSuccess = createAction(
  FolderOverviewActionTypes.CHANGE_FOLDER_VERSION_SUCCESS,
  props<{ folder: FolderVersion }>()
)

const trafficScopes = createAction(
  FolderOverviewActionTypes.TRAFFIC_SCOPES,
  props<{ id: number; scopeIds: number[] }>()
)
const trafficScopesFail = createAction(FolderOverviewActionTypes.TRAFFIC_SCOPES_FAIL, props<{ error: Error }>())
const trafficScopesSuccess = createAction(
  FolderOverviewActionTypes.TRAFFIC_SCOPES_SUCCESS,
  props<{ trafficStatus: FolderTrafficStatus }>()
)

export const FolderOverviewActions = {
  getCurrentFolder,
  getCurrentFolderFail,
  getCurrentFolderSuccess,
  deleteFolder,
  deleteFolderFail,
  deleteFolderSuccess,
  archiveFolder,
  archiveFolderFail,
  archiveFolderSuccess,
  unarchiveFolder,
  unarchiveFolderFail,
  unarchiveFolderSuccess,
  updateFolder,
  updateFolderFail,
  updateFolderSuccess,
  getRetainedHoursStats,
  getRetainedHoursStatsFail,
  getRetainedHoursStatsSuccess,
  changeFolderVersion,
  changeFolderVersionFail,
  changeFolderVersionSuccess,
  trafficScopes,
  trafficScopesFail,
  trafficScopesSuccess,
}
